import { render, staticRenderFns } from "./cateBlack.vue?vue&type=template&id=d5cb26e0&scoped=true"
import script from "./cateBlack.vue?vue&type=script&lang=js"
export * from "./cateBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cb26e0",
  null
  
)

export default component.exports